export default "<div id=\"chartdiv\"></div>"